import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { UserActions } from './user.actions';
import { ProfileService } from '../../services';
import { User } from '../../types';

@Injectable()
export class UserEffects {
  private actions = inject(Actions);
  private profileService = inject(ProfileService);

  initUser$: Observable<Action> = createEffect(
    () =>
      this.actions.pipe(
        ofType(UserActions.initUser),
        map(() => this.profileService.getUser()),
        switchMap(user => of(UserActions.setUser({ user })))
      ),
    { dispatch: true }
  );

  setUser$: Observable<Action> = createEffect(
    () =>
      this.actions.pipe(
        ofType(UserActions.setUser),
        switchMap(() => of(UserActions.stopUpdate()))
      ),
    { dispatch: true }
  );

  addUser$: Observable<Action> = createEffect(
    () =>
      this.actions.pipe(
        ofType(UserActions.addUser),
        tap(({ tokenResponse }) => {
          const backendUser = tokenResponse.user as User;
          this.profileService.updateUserToken(tokenResponse.token);
          this.profileService.updateUserData(backendUser);
          // this.brazeService.changeUser(backendUser.uuid);
        }),
        switchMap(() => of(UserActions.initUser()))
      ),
    { dispatch: true }
  );
}
